export function ArrowRight() {
	return <span className="icon-new icon-chevron-right-grey icon-24" />;
}

export default ArrowRight;
